export default __webpack_public_path__ + "static/media/EM1960.34I-43234_-25848_0.3bd49c89.jpg";